import React, { useState, useEffect } from "react";
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const MagicSquareGame = () => {
  const [size, setSize] = useState(3);
  const [cells, setCells] = useState(Array(9).fill(""));
  const [numbers, setNumbers] = useState([]);
  const [message, setMessage] = useState("");

  const solutions = {
    "3": [8, 1, 6, 3, 5, 7, 4, 9, 2],
    "4": [16, 3, 2, 13, 5, 10, 11, 8, 9, 6, 7, 12, 4, 15, 14, 1]
  };

  useEffect(() => {
    resetGame();
  }, [size]);

  const shuffle = (arr) => {
    const shuffled = [...arr];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const resetGame = () => {
    const total = size * size;
    setCells(Array(total).fill(""));
    const shuffled = shuffle([...Array(total)].map((_, i) => i + 1));
    setNumbers(shuffled);
    setMessage("");

    // Reset visibility for all draggable numbers
    shuffled.forEach((num) => {
      const el = document.getElementById(`num-${num}`);
      if (el) el.style.visibility = "visible";
    });
  };

  const handleDrop = (index, num) => {
    if (cells[index]) return;
    const updatedCells = [...cells];
    updatedCells[index] = num;
    setCells(updatedCells);
    document.getElementById(`num-${num}`).style.visibility = "hidden";
  };

  const handleDragStart = (e, num) => {
    e.dataTransfer.setData("text/plain", num);
  };

  const handleCellClick = (index) => {
    const num = cells[index];
    if (!num) return;
    document.getElementById(`num-${num}`).style.visibility = "visible";
    const updatedCells = [...cells];
    updatedCells[index] = "";
    setCells(updatedCells);
  };

  const checkMagic = () => {
    const current = cells.map(c => parseInt(c) || 0);
    const correct = JSON.stringify(current) === JSON.stringify(solutions[size]);
    setMessage(
      correct
        ? "🎉 Magic Complete! Everything is in the right place!"
        : "🧐 Not quite—some numbers are incorrect."
    );
    if (correct) {
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    }
  };

  const nextLevel = () => {
    setSize(size === 3 ? 4 : 3);
  };

  const gridStyle = {
    display: "grid",
    gap: "10px",
    justifyContent: "center",
    margin: "20px auto",
    gridTemplateColumns: `repeat(${size}, 60px)`
  };

  const cellStyle = (index) => ({
    background: "#212529",
    border: "2px solid #6fffe9",
    fontSize: "20px",
    height: "60px",
    width: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    transition: "background 0.3s",
    position: "relative",
    backgroundColor:
      parseInt(cells[index]) === solutions[size][index] ? "#43aa8b" : "#212529"
  });

  return (
    <div
      style={{
        fontFamily: "Segoe UI, sans-serif",
        background: "radial-gradient(circle, #0f0c29, #302b63, #24243e)",
        color: "#fff",
        textAlign: "center",
        padding: 20,
        minHeight: "100vh"
      }}
    >
      <style>{`
        @media (max-width: 600px) {
          .grid-cell {
            width: 45px !important;
            height: 45px !important;
            font-size: 16px !important;
          }
          .draggable {
            padding: 8px 12px !important;
            font-size: 16px !important;
          }
          button {
            font-size: 14px !important;
            padding: 8px 12px !important;
          }
          h1 {
            font-size: 1.5em !important;
          }
        }
      `}</style>

      <h1 style={{ color: "#fcbf49", fontSize: "2em" }}>✨ Magic Square</h1>

      <div style={gridStyle}>
        {cells.map((num, i) => (
          <div
            key={i}
            className="grid-cell"
            style={{ ...cellStyle(i) }}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => handleDrop(i, e.dataTransfer.getData("text/plain"))}
            onClick={() => handleCellClick(i)}
          >
            {num}
          </div>
        ))}
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "10px",
          marginTop: "20px"
        }}
      >
        {numbers.map((num) => (
          <div
            key={num}
            id={`num-${num}`}
            className="draggable"
            draggable
            onDragStart={(e) => handleDragStart(e, num)}
            style={{
              background: "#3a0ca3",
              border: "2px solid #fcbf49",
              borderRadius: "5px",
              padding: "10px 14px",
              fontSize: "18px",
              cursor: "grab",
              userSelect: "none",
              color: "#fff"
            }}
          >
            {num}
          </div>
        ))}
      </div>

      <div style={{ marginTop: "20px" }}>
        <button
          onClick={checkMagic}
          style={{
            padding: "10px 15px",
            margin: "5px",
            fontSize: "16px",
            background: "#f3722c",
            border: "none",
            color: "white",
            cursor: "pointer",
            borderRadius: "6px"
          }}
        >
          Check
        </button>
        <button
          onClick={resetGame}
          style={{
            padding: "10px 15px",
            margin: "5px",
            fontSize: "16px",
            background: "#f3722c",
            border: "none",
            color: "white",
            cursor: "pointer",
            borderRadius: "6px"
          }}
        >
          Reset
        </button>
        <button
          onClick={nextLevel}
          style={{
            padding: "10px 15px",
            margin: "5px",
            fontSize: "16px",
            background: "#f3722c",
            border: "none",
            color: "white",
            cursor: "pointer",
            borderRadius: "6px"
          }}
        >
          Next
        </button>
      </div>

      <div style={{ marginTop: "15px", fontSize: "20px", color: "#ffe66d" }}>{message}</div>
    </div>
  );
};

export default MagicSquareGame;
